import FlashMessage from '../components/FlashMessage.vue';
import ModalsModal from '../components/Modals/Modal.vue';
import ModalsContinueShopping from '../components/Modals/ContinueShopping.vue';
import Carousel from '../components/Carousel.vue';
import StoreAddToBasket from '../components/Store/AddToBasket.vue';
import VariantPicker from '../components/Store/ECommerce/VariantPicker.vue';
import ProductGroup from '../components/Store/ECommerce/ProductGroup.vue';

import CheckoutPageProductInfo from '../components/Store/ECommerce/Checkout/ProductInfo.vue';
import ProductPageProducctInfo from '../components/Store/ECommerce/ProductPage/ProductInfo.vue';
import BrickDimensionDisplay from '../components/Store/ECommerce/BrickDimensionDisplay.vue';


// register all components
export default {
  install(app) {
    app.component('u-brick-library', () => import('../components/BrickLibrary.vue'));
    // app.component('u-buttons-basket-button', ButtonsBasketButton);
    // app.component('u-buttons-menu-button', ButtonsMenuButton);
    // app.component('u-buttons-search-button', ButtonsSearchButton);
    app.component('u-brick-variation-select', () => import('../components/BrickVariationSelect.vue'));
    // app.component('u-image-picker', ImagePicker);
    app.component('u-payment', () => import('../components/Payment.vue'));
    app.component('u-flash-message', FlashMessage);
    app.component('u-modals-modal', ModalsModal);
    app.component('u-modals-continue-shopping', ModalsContinueShopping);
    app.component('u-uploader', () => import('../components/Uploader.vue'));
    // app.component('u-address-lookup', AddressLookup);
    // app.component('u-icons-close-icon', IconsCloseIcon);
    // app.component('u-icons-search-icon', IconsSearchIcon);
    // app.component('u-icons-chevron-icon', IconsChevronIcon);
    // app.component('u-icons-basket-icon', IconsBasketIcon);
    // app.component('u-icons-hamburger-icon', IconsHamburgerIcon);
    app.component('u-brick-lookup', () => import('../components/BrickLookup.vue'));
    app.component('u-carousel', Carousel);
    app.component('u-add-to-basket', StoreAddToBasket);
    app.component('u-variant-picker', VariantPicker);
    app.component('u-checkout-page-product-info', CheckoutPageProductInfo);
    app.component('u-product-page-product-info', ProductPageProducctInfo);
    app.component('u-brick-dimension-display', BrickDimensionDisplay);
    app.component('u-product-group', ProductGroup);
    app.component('u-basket', () => import('../components/Store/Basket.vue'));
    app.component('u-basket-short', () => import('../components/Store/BasketShort.vue'));
    app.component('u-brick-select', () => import('../components/BrickSelect.vue'));
    app.component('u-marquee', () => import('../components/Marquee.vue'));
    app.component('u-brick-calculator', () => import('../components/BrickCalculator.vue'));
    app.component('u-cart-icon', () => import('../components/CartIcon.vue'));
    app.component('u-tooltip', () => import('../components/Tooltip.vue'));

    app.component('u-trustpilot-trust-box', () => import("../components/TrustpilotTrustBox.vue"));
  }
};
